module.exports = __webpack_public_path__ + "assets/img/Blackpurl-Landing-Page-w720.b80276e6.webp";